import { render, staticRenderFns } from "./personal-information.vue?vue&type=template&id=703185fa"
import script from "./personal-information.vue?vue&type=script&lang=ts"
export * from "./personal-information.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiInput: require('/vercel/path0/components/ui/input.vue').default,UiInputPhoneNumber: require('/vercel/path0/components/ui/input-phone-number.vue').default})
